import React, { Component } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
//import CommonComments from './../../../common/Comments';
import PaginationComponent from './../../../common/Pagination';
import {
    GET_CompanyDashboard_PayrollVendorReportDetailList, MarkAccountantApproval
    , MarkClientApproval, Vendor1099Mailed, Vendor1099Exported, AccountReconciliationReviewSummery
} from '../../../../appRedux/actions/ReportDetailAction';
import { ReportType, MaskTaxIdentifier, numberWithCommas, GetLastQuarterEndDate, LinkType } from '../../../common/commonServices'
import moment from 'moment';
import { bindActionCreators } from 'redux';
import CircularProgress from './../../../../components/CircularProgress';
import { toast } from 'react-toastify';
import HistoryIcon from '@material-ui/icons/History';
import VendorsLogHistory from '../../../common/vendorsHistoryModel'
import Tooltip from '@material-ui/core/Tooltip';
import './Report1099Status.css';

class Report1099Status extends Component {
    constructor(props) {
        super(props);

        let eDate = new Date();
        let sDate = new Date(eDate.getFullYear(), 0, 1);

        if (eDate.getMonth() <= 2) {
            sDate = new Date(sDate.getFullYear() - 1, 0, 1);
            eDate = new Date(eDate.getFullYear() - 1, 11, 31);
        }

        const years = [];
        const currentYear = new Date().getFullYear();
        for (let year = currentYear; year >= currentYear - 25; year--) {
            if (year >= 2020) {
                years.push(year);
            }
        }
        this.years = years

        this.state = {
            //parantData: this.props.location.state ? this.props.location.state : null,
            MissingData: [],
            companyId: 0,
            sortField: 'name',
            sortFormat: "A",
            PageNo: 1,
            PageSize: 10,
            ColorCode: "#f0ca4c",
            IsCommentModelOpen: false,
            sDate: sDate,
            eDate: eDate,
            loading: false,
            TotalRecords: 0,
            CommentReferenceId: 0,
            IsEmbeddedPage: false,
            SelectedRecords: [],
            SelectALL: false,
            ShowComplete: true,
            failedLog: 0,
            ACRSummary: "No",
            lastReconciledThrough: null,
            ShowHistoryModal: false,
            ShowMailedConfirm: false,
            MailedConfirmItem: null,
            ConfirmType: null, // 'Mailed' | 'Exported'
            ShowInfoPopup: false,
            InfoPopupType: null
        }
    }
    YearChange = (e) => {

        this.setState({ eDate: new Date(e.target.value, 11, 31), sDate: new Date(e.target.value, 0, 1), loading: true }, () => {

            this.GetReportData();
        });
    }

    componentDidMount() {
        let user = JSON.parse(localStorage.getItem('userData'));
        this.setState({
            companyId: user.companyId,
            loading: true
        }, () => {
            this.props.AccountReconciliationReviewSummery(user.companyId);
            this.GetReportData();
        });
    }

    componentWillReceiveProps(nextProps) {

        if (nextProps.ReportData !== this.props.ReportData) {
            if (nextProps.ReportData.transactionStatus === 0) {
                var totalrecords = 0;
                let items = nextProps.ReportData.returnObject;
                if (nextProps.ReportData.returnObject != null && nextProps.ReportData.returnObject.length > 0) {
                    totalrecords = nextProps.ReportData.returnObject[0].totalrows
                    items.map((dt, index) => {
                        items[index].MaskTax = MaskTaxIdentifier(dt.taxIdentifier);
                    });
                }
                this.setState({ MissingData: items, TotalRecords: totalrecords, PageSize: this.state.PageSize, PageNo: this.state.PageNo, loading: false });
            }
            else {
                toast.error(nextProps.ReportData.resultMsg);
                this.setState({ loading: false });
            }
        }
        if (nextProps.UpdateDescription !== this.props.UpdateDescription) {
            if (nextProps.UpdateDescription.transactionStatus === 0) {
                toast.success(`${nextProps.UpdateDescription.resultMsg}`);
                this.GetReportData();
            }
            else {
                this.setState({
                    loading: false
                }, () => {
                    toast.error(`${nextProps.UpdateDescription.resultMsg}`);
                });
            }
        }

        if (nextProps.ARCRSummary !== this.props.ARCRSummary) {
            if (nextProps.ARCRSummary.transactionStatus === 0) 
            {
                if(nextProps.ARCRSummary.returnObject.length>0)
                {
                    this.setState({ ACRSummary:nextProps.ARCRSummary.returnObject[0].haveAllCheckingAccounts?"Yes":"No",lastReconciledThrough:nextProps.ARCRSummary.returnObject[0].lastReconciledThrough});
                }                
            }
            else
            {
                toast.error(`${nextProps.ARCRSummary.resultMsg}`);
            }
            
        }

    }

    ChangePageSize = (size) => {
        this.setState({ 
            loading: true
            // loading: false
            , PageSize: parseInt(size), PageNo: 1 }, () => {
            this.GetReportData();
        });
    }

    ChangePage = (page) => {
        this.setState({ 
            loading: true
            // loading: false
            , PageNo: page, }, () => {
            this.GetReportData();
        });
    }
    CloseHistory = () => {
        this.setState({ ShowHistoryModal: false });
    }
    getHistory = (item) => {
        this.setState({ vendorID: item.vendorID, ShowHistoryModal: true })

    }

    openMailedConfirm = (item) => {
        this.setState({ ShowMailedConfirm: true, MailedConfirmItem: item, ConfirmType: 'Mailed' });
    }

    openExportedConfirm = (item) => {
        this.setState({ ShowMailedConfirm: true, MailedConfirmItem: item, ConfirmType: 'Exported' });
    }

    closeMailedConfirm = () => {
        this.setState({ ShowMailedConfirm: false, MailedConfirmItem: null, ConfirmType: null });
    }

    confirmUnmail = () => {
        const { MailedConfirmItem, ConfirmType } = this.state;
        if (MailedConfirmItem && ConfirmType) {
            this.UpdateVendorAction(ConfirmType, MailedConfirmItem, false);
        }
        this.setState({ ShowMailedConfirm: false, MailedConfirmItem: null, ConfirmType: null });
    }

    openInfoPopup = (type) => {
        this.setState({ ShowInfoPopup: true, InfoPopupType: type });
    }

    closeInfoPopup = () => {
        this.setState({ ShowInfoPopup: false, InfoPopupType: null });
    }

    GetReportData(IsRefresh = false) {
        let state = this.state;
        let body = {
            companyID: state.companyId,
            reportType: ReportType.Vendor1099StatusReport,
            fromDate: moment(state.sDate).format("MM/DD/YYYY"),
            toDate: moment(state.eDate).format("MM/DD/YYYY"),
            sortField: state.sortField,
            sortFormat: state.sortFormat,
            pageNumber: state.PageNo,
            pageSize: state.PageSize,
            needUpdatQBORecords: IsRefresh
        };

        this.setState({ loading: true });
        this.props.GET_CompanyDashboard_PayrollVendorReportDetailList(body);
    }


    SelectALL = (e) => {
        if (this.state.MissingData.length > 0) {
            if (e.target.checked) {
                let all = [];
                let data = this.state.MissingData;
                for (let i = 0; i < data.length; i++) {
                    all.push(data[i].listID);
                }
                this.setState({ SelectALL: true, SelectedRecords: all });
            }
            else {
                this.setState({ SelectALL: false, SelectedRecords: [] });
            }
        }
    }


    onSortChange = (fieldName) => {
        if (this.state.sortField == fieldName) {
            let formate = this.state.sortFormat == 'A' ? 'D' : 'A';
            this.setState({ sortFormat: formate,
                 loading: true
                // loading: false
                 }, () => {
                this.GetReportData();
            });
        } else {
            this.setState({ sortField: fieldName, sortFormat: 'A', 
            loading: true
            // loading: false
         }, () => {
                this.GetReportData();
            });
        }
    }
    onRefreshDataClick = () => {
        if (!this.state.loading) {
            this.setState({ loading: true }, () => {
                this.GetReportData(true);
            });
        }
    }

    OnApplyApproved = () => {
        let selectedData = this.state.SelectedRecords;
        if (selectedData == null || selectedData.length === 0) {
            toast.error("Please select atleast 1 record for processing request");
            return false;
        }
        let body = {
            "ids": selectedData,
            "reportType": ReportType.IssueHousingAllowanceMemo,
            "companyID": this.state.companyId,
        }

        // this.setState({ loading: true }, () => {
        //     this.props.IncludeHAMemo(body);
        // });
    }

    UpdateVendorAction = (type, item, isChecked) => {

        let errMsg = "Accountant and Client approval is required before Export and Mailed";

        const currentItem = this.state.MissingData.find(el => el.listID === item.listID) || item;

        if (type != null) {
            let body = {
                "companyID": this.state.companyId,
                "ids": [parseInt(item.listID)],
                "reportType": ReportType.Vendor1099PendingAccountantApproval,
                "IsRemove": !isChecked
            }
            if (type === "Accountant") {
                body.reportType = ReportType.Vendor1099PendingAccountantApproval;
                this.setState({ loading: true }, () => {
                    this.props.MarkAccountantApproval(body);
                });
            }
            else if (type === "Client") {
                body.reportType = ReportType.Vendor1099PendingClientApproval;
                this.setState({ loading: true }, () => {
                    this.props.MarkClientApproval(body);
                });
            }
            else if (type === "Exported") {
                body.reportType = ReportType.Vendor1099StatusReport;
                if (body.IsRemove) {
                    if (currentItem.alreadyExported) {
                        this.setState({ loading: true }, () => {
                            this.props.Vendor1099Exported(body);
                        });
                    }
                }
                else {
                    if (currentItem.vendor1099ApprovedByAccountant) {
                        if (currentItem.vendor1099ApprovedByClient) {
                            if (currentItem.readyForExport) {
                                this.setState({ loading: true }, () => {
                                    this.props.Vendor1099Exported(body);
                                });
                            }
                            else {
                                toast.error("Vendor details missing or amount is not as expected or must have anyone of from this vendor type 'Rent','Royalties','Other','Non-Employee Compensation'");
                            }
                        }
                        else {
                            toast.error(errMsg);
                        }
                    }
                    else {
                        toast.error(errMsg);
                    }
                }
            }
            else if (type === "Mailed") {
                body.reportType = ReportType.Confirm1099WereMailed;
                if (body.IsRemove) {
                    if (currentItem.alreadyMailed || currentItem.isMailed) {
                        this.setState({ loading: true }, () => {
                            this.props.Vendor1099Mailed(body);
                        });
                    }
                }
                else {
                    if (currentItem.vendor1099ApprovedByAccountant && currentItem.vendor1099ApprovedByClient && currentItem.alreadyExported) {
                        this.setState({ loading: true }, () => {
                            this.props.Vendor1099Mailed(body);
                        });
                    }
                    else {
                        toast.error(errMsg);
                    }
                }
            }
        }
    }

    onCheckboxClick = (item, type, isChecked) => {
        // Show popup when Exported is checked and user tries to deselect Accountant or Client
        if (!isChecked && item.alreadyExported && (type === "Accountant" || type === "Client")) {
            this.openInfoPopup('Accounting');
            return;
        }
        // Show message when trying to deselect dependencies while Mailed is checked
        if (!isChecked && item.alreadyMailed && (type === "Accountant" || type === "Client" || type === "Exported")) {
            this.openInfoPopup('Accounting');
            return;
        }

        let existInArray = false;
        let data = this.state.SelectedRecords;
        if (data != null && data.length > 0 && data.indexOf(item.listID) > -1) {
            existInArray = true;
        }

        if (isChecked) {
            if (!existInArray) {
                data.push(item.listID);
            }
        }
        else {
            if (existInArray) {
                data.splice(data.indexOf(item.listID), 1);
            }
        }
        this.UpdateVendorAction(type, item, isChecked);
        let all = (data.length == this.state.MissingData.length) ? true : false;
        this.setState({ SelectedRecords: data, SelectALL: all, editIndex: -1 });
    }


    render() {
        return (
            <div className="dashboardPage report-1099-status-page">
                <div className="page-heading page-title-box d-sm-flex justify-content-sm-between align-items-sm-center">
                    <h2 className="title mb-3 mb-sm-0 report-1099-status-title">{JSON.parse(localStorage.getItem('userData')) != null ? JSON.parse(localStorage.getItem('userData')).companyName : ""} | {LinkType.StatusReport1099}</h2>
                </div>
                {this.state.loading ?
                    <div className="report-1099-status-loader">
                        <CircularProgress />
                    </div>
                    :
                    <div className="padding-box app-wrapper">
                        {this.state.ShowHistoryModal ?  <VendorsLogHistory  Module="Vendors History"
                    CompanyId={this.state.companyId}
                    VendorId={this.state.vendorID}
                    CloseHistory={this.CloseHistory}/>: '' }
                        <div className="report-1099-status-controls">
                                        <div className="arc_summary">
                                        <span>Have all checking accounts been reconciled through {this.state.lastReconciledThrough}?: {this.state.ACRSummary}  </span>
                                        </div>
                                        <div className="report-1099-status-actions">
                                        <span>Select Year:</span>
                                         <select className="select-box arrow-box report-1099-status-year" name="year" onChange={(e) => this.YearChange(e)} value={this.state.eDate.getFullYear()}>
                                            {/* <option value=""></option> */}
                                            {this.years.map((option, index) => (
                                               <option key={index} value={option}>
                                                 {option}
                                               </option>
                                             ))}
                                        </select>
                                            {/* <Button variant="contained" className=" jr-btn g-teal  text-white refresh-btn graycolor" onClick={() => this.OnApplyApproved()}>Exported </Button> */}
                                            <Button variant="contained" style={{ backgroundColor: this.state.ColorCode }} className="jr-btn text-white refresh-btn" onClick={() => this.onRefreshDataClick()}  ><i className="zmdi zmdi-refresh "></i> Refresh Data</Button>
                                        </div>
                        </div>
                        <div className="table-responsive-material report-1099-status-table-wrap">
                            <table className="table tablebox account-reconcilliation report-1099-status-table">
                                <thead>
                                    <tr style={{ backgroundColor: this.state.ColorCode }}>
                                        <th className={`td-width ${this.state.sortField == 'name' ? this.state.sortFormat == 'A'
                                            ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('name')}><p className="table-th-title">Display Name</p> </th>
                                        {/* <th className={`td-width  ${this.state.sortField === 'familyName' ? this.state.sortFormat == 'A'
                                            ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('familyName')}><p className="table-th-title"> Last Name</p></th> */}
                                        <th className={`td-width ${this.state.sortField == 'companyName' ? this.state.sortFormat == 'A'
                                            ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('companyName')}><p className="table-th-title">Company Name</p> </th>
                                        <th className={`td-width  ${this.state.sortField === 'address' ? this.state.sortFormat == 'A'
                                            ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('address')}><p className="table-th-title"> Address</p></th>
                                        <th className={`td-width  ${this.state.sortField === 'taxIdentifier' ? this.state.sortFormat == 'A'
                                            ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('taxIdentifier')}><p className="table-th-title"> Tax Identifier</p></th>
                                        <th className={`td-width  ${this.state.sortField === 'vendorType' ? this.state.sortFormat == 'A'
                                            ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('vendorType')}><p className="table-th-title"> Vendor Type</p></th>
                                        <th className={`td-width text-center ${this.state.sortField === 'totalPayment' ? this.state.sortFormat == 'A'
                                            ? "asending" : "desending" : ''}`} onClick={() => this.onSortChange('totalPayment')}><p className="table-th-title"> Total Payment</p></th>
                                        <th className="td-width-90">
                                            Approved by Accountant
                                        </th>
                                        <th className="td-width-90">
                                            Approved by Client
                                        </th>
                                        <th className="td-width-90">
                                            Exported
                                        </th>
                                        <th className="td-width-90">
                                            Mailed
                                        </th>
                                        <th className="td-width-90">
                                        W-9/1099 Reporting Issues
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.MissingData != null && this.state.MissingData.length > 0 ?
                                        <React.Fragment>
                                            {this.state.MissingData.map((item, i) => (
                                                <tr key={item.listID}>
                                                    <td>{item.displayName}</td>
                                                    {/* <td>{item.familyName}</td> */}
                                                    <td>{item.companyName}</td>
                                                    <td>{item.address}</td>
                                                    <td>{item.taxIdentifier}</td>
                                                    <td>{item.vendorType}</td>
                                                    <td className="text-center">{numberWithCommas(item.totalPayment)}</td>
                                                    <td >
                                                        <label className="container101" onClick={(e) => { e.preventDefault(); this.onCheckboxClick(item, "Accountant", !item.vendor1099ApprovedByAccountant); }}>
                                                            <input className="second-check-box" checked={!!item.vendor1099ApprovedByAccountant} readOnly type="checkbox" />
                                                            <span className="checkmark101 green_CheckMark"></span>
                                                        </label>
                                                    </td>
                                                    <td>
                                                        <label className="container101" onClick={(e) => { e.preventDefault(); this.onCheckboxClick(item, "Client", !item.vendor1099ApprovedByClient); }}>
                                                            <input className="second-check-box" checked={!!item.vendor1099ApprovedByClient} readOnly type="checkbox" />
                                                            <span className="checkmark101 green_CheckMark"></span>
                                                        </label>
                                                    </td>
                                                    <td>
                                                        <label className="container101" onClick={(e) => {
                                                            e.preventDefault();
                                                            if (item.alreadyExported) {
                                                                this.openExportedConfirm(item);
                                                            } else {
                                                                this.onCheckboxClick(item, "Exported", true);
                                                            }
                                                        }}>
                                                            <input className="second-check-box" checked={!!item.alreadyExported} readOnly type="checkbox" />
                                                            <span className="checkmark101 green_CheckMark"></span>
                                                        </label>
                                                    </td>
                                                    <td>
                                                        <label className="container101" onClick={(e) => {
                                                            e.preventDefault();
                                                            if (item.alreadyMailed) {
                                                                this.openMailedConfirm(item);
                                                            } else {
                                                                this.onCheckboxClick(item, "Mailed", true);
                                                            }
                                                        }}>
                                                            <input className="second-check-box" checked={!!item.alreadyMailed} readOnly type="checkbox" />
                                                            <span className="checkmark101 green_CheckMark"></span>
                                                        </label>
                                                    </td>
                                                    <td><label className="container101">
                                                    <Tooltip title="W-9/1099 Reporting Issues history"><HistoryIcon onClick={(e)=>{this.getHistory(item)}}/></Tooltip> </label></td>
                                                </tr>
                                            ))}
                                        </React.Fragment>
                                        :
                                        <tr>
                                            <td className="text-center" colSpan="10">
                                            No issues here! Keep up the good work!
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <PaginationComponent
                            key={this.state.MissingData.length}
                            selectedPageNo={this.state.PageNo}
                            selectedSize={this.state.PageSize}
                            TotalRecords={this.state.TotalRecords}
                            ChangePageSize={this.ChangePageSize}
                            ChangePage={this.ChangePage}
                            CurrentRecords={this.state.MissingData.length}
                        >
                        </PaginationComponent>

                        {this.state.ShowMailedConfirm &&
                            <div style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0,0,0,0.4)',
                                zIndex: 1050,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div style={{
                                    backgroundColor: '#fff',
                                    padding: '20px 24px',
                                    borderRadius: 4,
                                    maxWidth: 500,
                                    width: '100%',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                                }}>
                                    <p style={{ marginBottom: 16 }}>
                                        I have confirmed the 1099 was not filed electronically.
                                    </p>
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
                                        <Button
                                            color="primary"
                                            onClick={this.closeMailedConfirm}
                                            style={{ marginRight: 8 }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            color="primary"
                                            onClick={this.confirmUnmail}
                                        >
                                            Confirm
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        }
                        {this.state.ShowInfoPopup &&
                            <div style={{
                                position: 'fixed',
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                backgroundColor: 'rgba(0,0,0,0.4)',
                                zIndex: 1050,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <div style={{
                                    backgroundColor: '#fff',
                                    padding: '20px 24px',
                                    borderRadius: 4,
                                    maxWidth: 700,
                                    width: '100%',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.3)'
                                }}>
                                    {this.state.InfoPopupType === 'Accounting' &&
                                        <div>
                                            <p>
                                                The 1099 for this vendor is being processed or has been filed electronically with the IRS.
                                                Please check the 1099 filing software to confirm the vendor&apos;s 1099 electronic filing status.
                                            </p>
                                            <p>
                                                If the 1099 HAS NOT been filed electronically, you may deselect the &quot;Mailed&quot; and
                                                &quot;Exported&quot; status.
                                            </p>
                                            <p>
                                                If the 1099 has been filed electronically, you must use the 1099 filing software to void the
                                                1099 or issue a corrected 1099. If the 1099 is voided, update the 1099 Review Report for this
                                                1099. If the 1099 amount has been corrected, make sure the Compliance Center reflects the
                                                correct 1099 total for the vendor.
                                            </p>
                                        </div>
                                    }
                                    {this.state.InfoPopupType === 'Client' &&
                                        <div>
                                            <p>
                                                The 1099 for this vendor is being processed or has been filed electronically with the IRS.
                                                Please call our office or send a message to&nbsp;
                                                <a href="mailto:accounting@churchcpa.com">accounting@churchcpa.com</a>&nbsp;or via Basecamp
                                                to confirm the vendor&apos;s 1099 electronic filing and mailing status.
                                            </p>
                                            <p>
                                                Please explain the discrepancy so that we can either void or correct the 1099.
                                            </p>
                                        </div>
                                    }
                                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                                        <Button
                                            variant="contained"
                                            style={{ backgroundColor: this.state.ColorCode }}
                                            className="jr-btn jr-btn-sm text-white"
                                            onClick={this.closeInfoPopup}
                                        >
                                            OK
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        ReportData: state.ReportData.ReportData,
        UpdateDescription: state.ReportData.UpdateDescription,
        ARCRSummary: state.ReportData.ARCRSummary
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        GET_CompanyDashboard_PayrollVendorReportDetailList,
        MarkAccountantApproval,
        MarkClientApproval,
        Vendor1099Mailed,
        Vendor1099Exported,
        AccountReconciliationReviewSummery
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Report1099Status);